export default __webpack_public_path__ + "static/media/link.6a92722a.svg";